import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'widgetRepairSignin',
  state: {
    demoData: {}
  },
  effects: {
    * getData ({ payload }, { call, put }) {
      const res = yield call(service.getData, payload)
      if (res.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * usePropKpiNoCheck ({ payload }, { call, put }) {
      try {
        const res = yield call(service.usePropKpiNoCheck, payload)
        if (res.status !== HTTP_CODE.success) {
          throw new Error(res.data.err)
        }
        return res.data
      } catch (err) {
        console.log(err, 'errrrr')
      }
    },
    * usePropSettingTips ({ payload }, { call, put }) {
      const res = yield call(service.usePropSettingTips, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
